// extracted by mini-css-extract-plugin
export default {"root":"Status_root__j9Eu1","state0":"Status_state0__12XqY","state1":"Status_state1__HQ9WB","state2":"Status_state2__tRz5E"};